import adminApiClient from './apiClient.js';

export const spacesApi = {
  list: async (params = {}) => {
    const { data } = await adminApiClient.get('/spaces/', { params });
    return data;
  },
  getScore: async (spaceId) => {
    const { data } = await adminApiClient.get(`/spaces/${spaceId}/score`);
    return data;
  },
  setVerificado: async (spaceId, verificado) => {
    const { data } = await adminApiClient.patch(`/spaces/${spaceId}/verificado`, { verificado });
    return data;
  },
  listReservas: async (params = {}) => {
    const { data } = await adminApiClient.get('/spaces/reservas', { params });
    return data;
  },
  createReserva: async (payload) => {
    const { data } = await adminApiClient.post('/spaces/reservas', payload);
    return data;
  },
  updateReserva: async (reservaId, payload) => {
    const { data } = await adminApiClient.patch(`/spaces/reservas/${reservaId}`, payload);
    return data;
  },
  deleteReserva: async (reservaId) => {
    await adminApiClient.delete(`/spaces/reservas/${reservaId}`);
  },
};

export default spacesApi;
